import React from "react";
import "../component/productUnitTable.css";

const ProductUnitTable = ({
  productUnit,
  onEditProductUnitClicked,
  onDeleteProductUnitClicked,
}) => {
  const editProductUnit = (productUnit) => {
    onEditProductUnitClicked(productUnit);
  };

  const deleteProductUnit = (productUnit) => {
    onDeleteProductUnitClicked(productUnit);
  };

  return (
    <div className="product-unit-table-container">
      <table className="product-unit-table">
        <thead>
          <tr>
            <th width="100px">No</th>
            <th>Nama Unit Produk</th>
            <th width="150px">Actions</th>
          </tr>
        </thead>
        <tbody>
        {productUnit.length > 0 ? (
            productUnit.map((unit, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{unit.product_unit_name}</td>
                <td>
                  <button
                    className="edit-doctor-specialist-button"
                    onClick={() => {
                      editProductUnit(unit);
                    }}
                  >
                    Edit
                  </button>
                  <button
                    className="delete-doctor-specialist-button"
                    onClick={() => {
                      deleteProductUnit(unit);
                    }}
                  >
                    Hapus
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" style={{ textAlign: "center" }}>
                Data tidak tersedia
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ProductUnitTable;
